module.exports = __webpack_public_path__ + "static/media/reset_password.83244d0e.svg";